import styled, { css } from 'styled-components/macro';
import { Checkbox, FormControlLabel } from '@mui/material';

export const StyledCheckBox = styled(Checkbox)`
  && {
    /* The glyph is an svgr icon inside .dsc-icon-wrapper, which sizes it via font-size + 1em.
       Setting it on the Checkbox root alone never reached the svg. */
    .dsc-icon-wrapper {
      font-size: var(--control-size, 24px);
    }

    font-size: var(--control-size, 24px);
    color: var(--languidLavender);

    &.Mui-checked {
      color: var(--royalBlue);
    }

    &.MuiCheckbox-indeterminate {
      color: ${({ $disabled }) => ($disabled ? 'var(--languidLavender)' : 'var(--royalBlue)')};
    }
    ${({ checked, indeterminate }) =>
      !checked &&
      !indeterminate &&
      css`
        :hover {
          svg {
            stroke: var(--control-hover-border, var(--midnightGreen));
          }
        }
      `}
  }
`;

export const StyledLabel = styled(FormControlLabel).attrs({
  className: 'dsc-checkbox-label'
})`
  font-size: 13px;
  color: var(--checkbox-label-color, var(--trolleyGrey));
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.1;
  margin-right: unset;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;

  .MuiButtonBase-root {
    padding: 9px !important;
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
    font-family: var(--app-font) Averta, sans-serif;
  }
`;

export const StyledCheckBoxItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  width: ${({ $width }) => $width};
  .keyItem {
    margin-right: 3px;
  }

  .count {
    font-size: 12px;
    width: 25px;
    text-align: right;
  }
`;

export const MultiCheckboxWrapper = styled.div.attrs({ className: 'dsc-multiCheckbox' })`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MultiCheckboxHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: var(--select-text-color);
`;
export const CheckboxesWrapper = styled.div.attrs({
  className: 'dsc-checkbox-wrapper'
})`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

// Children of a hierarchical option, indented by the width of a checkbox.
export const SubCheckboxesWrapper = styled.div.attrs({
  className: 'dsc-checkbox-sub-wrapper'
})`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-left: 30px;
`;

export const ExpandButtonWrapper = styled.div`
  margin-left: -16px;
`;
export const ClearButtonWrapper = styled.div`
  margin-right: -16px;
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;
